/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HeurekaIntegrationData
 */
export interface HeurekaIntegrationData {
    /**
     * 
     * @type {string}
     * @memberof HeurekaIntegrationData
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof HeurekaIntegrationData
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof HeurekaIntegrationData
     */
    updated?: string;
    /**
     * 
     * @type {string}
     * @memberof HeurekaIntegrationData
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof HeurekaIntegrationData
     */
    project?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof HeurekaIntegrationData
     */
    errors?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof HeurekaIntegrationData
     */
    authorizationSuccessful?: boolean;
    /**
     * 
     * @type {string}
     * @memberof HeurekaIntegrationData
     */
    lastRegularUpdate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HeurekaIntegrationData
     */
    lastHistoricalUpdate?: string | null;
}

/**
 * Check if a given object implements the HeurekaIntegrationData interface.
 */
export function instanceOfHeurekaIntegrationData(value: object): value is HeurekaIntegrationData {
    return true;
}

export function HeurekaIntegrationDataFromJSON(json: any): HeurekaIntegrationData {
    return HeurekaIntegrationDataFromJSONTyped(json, false);
}

export function HeurekaIntegrationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): HeurekaIntegrationData {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'created': json['created'] == null ? undefined : json['created'],
        'updated': json['updated'] == null ? undefined : json['updated'],
        'name': json['name'] == null ? undefined : json['name'],
        'project': json['project'] == null ? undefined : json['project'],
        'errors': json['errors'] == null ? undefined : json['errors'],
        'authorizationSuccessful': json['authorizationSuccessful'] == null ? undefined : json['authorizationSuccessful'],
        'lastRegularUpdate': json['lastRegularUpdate'] == null ? undefined : json['lastRegularUpdate'],
        'lastHistoricalUpdate': json['lastHistoricalUpdate'] == null ? undefined : json['lastHistoricalUpdate'],
    };
}

export function HeurekaIntegrationDataToJSON(json: any): HeurekaIntegrationData {
    return HeurekaIntegrationDataToJSONTyped(json, false);
}

export function HeurekaIntegrationDataToJSONTyped(value?: HeurekaIntegrationData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'created': value['created'],
        'updated': value['updated'],
        'name': value['name'],
        'project': value['project'],
        'errors': value['errors'],
        'authorizationSuccessful': value['authorizationSuccessful'],
        'lastRegularUpdate': value['lastRegularUpdate'],
        'lastHistoricalUpdate': value['lastHistoricalUpdate'],
    };
}

